import { useState } from "react"
import { MikanSpan } from "../Mikan"
import { accordion, accordionOpen, accordionTitle, accordionContent } from "./accordion.module.css"

const Accordion = ({ title, children }) => {
  const [isVisible, setIsVisible] = useState(false)

  const isVisibleHandler = () => {
    setIsVisible(!isVisible)
  }
  const styleAccordion = `${accordion} ${isVisible ? accordionOpen : ""}`

  return (
    <div className={styleAccordion}>
      <div
        className={accordionTitle}
        onClick={isVisibleHandler}
        onKeyDown={isVisibleHandler}
        role="button"
        aria-label="accordion"
        tabIndex={0}
      >
        <p>
          <MikanSpan text={title} />
        </p>
      </div>
      <div>
        {isVisible && (
          <div className={accordionContent}>
            <hr />
            {children}
          </div>
        )}
      </div>
    </div>
  )
}

export default Accordion
